module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av666-af7d02a74c224978f8d1a49c72626010.jpg";